import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";
import {
  ApprovalState,
  DATE_FORMAT,
  DisputeStatus,
  FLIGHT_PLAN_STATUS,
  TIME_FORMAT,
} from "../../../../../utils/constants";
import "../ViewHistoricalData.css";

dayjs.extend(utc);

const ViewHistoricalDataApprovedView = ({
  flightApprovalData,
  disputeStatus,
  flightPlanDetail,
}) => {
  // Filter to keep only the latest entry for each unique approvalState
  // Special handling: if both APPROVED_BY_AIRLINE and UPDATED_BY_AIRLINE exist, only keep the latest one
  const getLatestApprovalData = (data) => {
    if (!data || !Array.isArray(data)) return [];

    // Separate airline approvals from other approvals
    const airlineApprovals = data.filter(
      (item) =>
        item.approvalState === ApprovalState.APPROVED_BY_AIRLINE ||
        item.approvalState === ApprovalState.UPDATED_BY_AIRLINE
    );
    const otherApprovals = data.filter(
      (item) =>
        item.approvalState !== ApprovalState.APPROVED_BY_AIRLINE &&
        item.approvalState !== ApprovalState.UPDATED_BY_AIRLINE
    );

    // Get the latest airline approval (if any)
    let latestAirlineApproval = null;
    if (airlineApprovals.length > 0) {
      latestAirlineApproval = airlineApprovals.reduce((latest, item) => {
        if (
          !latest ||
          dayjs(item.reviewedAt).isAfter(dayjs(latest.reviewedAt))
        ) {
          return item;
        }
        return latest;
      });
    }

    // Group other approvals by state
    const groupedByState = otherApprovals.reduce((acc, item) => {
      const state = item.approvalState;
      if (
        !acc[state] ||
        dayjs(item.reviewedAt).isAfter(dayjs(acc[state].reviewedAt))
      ) {
        acc[state] = item;
      }
      return acc;
    }, {});

    // Combine latest airline approval with other approvals
    const allApprovals = latestAirlineApproval
      ? [latestAirlineApproval, ...Object.values(groupedByState)]
      : Object.values(groupedByState);

    // Sort by reviewedAt to maintain chronological order
    return allApprovals.sort((a, b) =>
      dayjs(a.reviewedAt).isBefore(dayjs(b.reviewedAt)) ? -1 : 1
    );
  };

  const filteredApprovalData = getLatestApprovalData(flightApprovalData);

  return (
    <div className="view-historical-data-approved-container">
      {flightPlanDetail?.status === FLIGHT_PLAN_STATUS.AA_APPROVAL &&
      flightPlanDetail?.isAutoCompleted ? (
        <div className="view-historical-data-approved-center">
          <div>
            Auto approved since no Action taken on Flight Roster by the officer.
          </div>
        </div>
      ) : (
        <>
          {filteredApprovalData?.map((item, index) => (
            <>
              <div key={index} className="edit-flight-approved">
                {(disputeStatus === DisputeStatus.RAISED ||
                  disputeStatus === DisputeStatus.AA_FORCED_BMS_COUNT ||
                  item?.airlineApproval === false) &&
                item?.approvalState === ApprovalState.APPROVED_BY_AIRLINE ? (
                  <div>{`Disputed By Airline`}</div>
                ) : item?.approvalState === ApprovalState.UPDATED_BY_AIRLINE ? (
                  <div>{`Updated by ${item?.name}`}</div>
                ) : item?.approvalState?.toLowerCase().includes("approved") ? (
                  <div>{`Approved by ${item?.name}`}</div>
                ) : item?.approvalState?.toLowerCase().includes("cancelled") ? (
                  <div>{`Cancelled by ${item?.name}`}</div>
                ) : (
                  <div>{item?.name}</div>
                )}
                <div>{`(${item?.email})`}</div>
                <div>
                  on {dayjs(item?.reviewedAt).format(DATE_FORMAT)} at{" "}
                  {dayjs(item?.reviewedAt).format(TIME_FORMAT)}
                </div>
              </div>
              {index + 1 !== filteredApprovalData.length && (
                <div className="edit-flight-approved-divider"></div>
              )}
            </>
          ))}
        </>
      )}
    </div>
  );
};

export default ViewHistoricalDataApprovedView;
